import { HomePageClient } from "commonModule/services/client"
import { defaultAxiosInstance } from "services/client"

export const apiHomePageClient = new HomePageClient(defaultAxiosInstance)
